export const typographyToken = {
	fontFamily: {
		global: [
			'Brown',
			'-apple-system',
			'BlinkMacSystemFont',
			'Segoe UI',
			'Roboto',
			'Helvetica',
			'Arial',
			'sans-serif',
			'Apple Color Emoji',
			'Segoe UI Emoji',
			'Segoe UI Symbol',
		],
	},

	fontSize: {
		'x-small': ['10.2px', '15.3px'],
		small: ['14px', '21px'],
		medium: ['16px', '24px'],
		large: ['20px', '25px'],
		'x-large': ['25px', '31.25px'],
		'2x-large': ['31.2px', '39px'],
		'3x-large': ['39.1px', '48.87px'],
		'4x-large': ['48.8px', '61px'],
	},
	fontWeight: {
		light: '300',
		regular: 'normal',
		bold: 'bold',
	},
} as const;
